/**
 * Anonymise some data like a credit card number or an IBAN
 * @param {string} s the data to anonymise
 * @param {number} safeStart the number of characters at the start to leave in tact
 * @param {number} safeEnd the number of characters at the end to leave in tact
 * @param {string} replacer a character that unsafe characters are to be replaced with
 * @param {string} safeChars characters that are safe; these will not be replaced
 */
export function anonymise(s, safeStart = 0, safeEnd = 4, replacer = '*', safeChars = ' ') {
  const _safe = Array.from(safeChars);
  const _chars = s.split('');
  const _start = _chars.slice(0, safeStart);
  const _end = _chars.slice(_chars.length - safeEnd);
  const _replaced = _chars
    .slice(safeStart, _chars.length - safeEnd)
    .map(char => (_safe.includes(char) ? char : replacer));
  return _start.concat(_replaced).concat(_end).join('');
}
